import { useEffect, useState } from 'react'

import QueryToJson from 'Utils/QueryToJson'
import getFileTypeSlug from 'Utils/getFileTypeSlug'

function useHandlePreviousSearch({
  data,
  selectedFilters,
  filtersOptions,
  shouldTrackSearch,
  setShouldTrackSearch,
  setSearchEnchantmentAction,
  searchEnchantmentAction,
  itemListId,
}) {
  const [originalSearchQuery, setOriginalSearchQuery] = useState(null)
  const [originalIndexes, setOriginalIndexes] = useState([])

  function saveSearchedKeywords(keywords, searchQuery) {
    localStorage.setItem('searchedKeywords', JSON.stringify({
      keywords,
      filters: selectedFilters,
      searchEnchantmentAction,
      searchQuery: searchQuery || itemListId,
      items: data.map(({ id }, index) => ({ id, index })),
    }))
  }

  function findStringDifference(string1, string2) {
    let difference = ''
    const maxLength = Math.max(string1.length, string2.length)

    for (let i = 0; i < maxLength; i += 1) {
      if (string1[i] !== string2[i]) {
        difference += string2[i] || ''
      }
    }

    return difference.trim().replace(/ /g, '+')
  }

  function clearPreviousSearchUseStates() {
    setOriginalIndexes([])
    window.itemListEnrichmentType = null
    setOriginalSearchQuery(null)
  }

  function getSelectedFilters() {
    const queryParams = QueryToJson(window.location.search.replace(/^\?/, ''))

    const {
      file_types: fileTypes,
      licenses,
      keywords,
      suggested_keywords: suggestedKeywords,
      ...rest
    } = queryParams

    const activeFilters = Object.entries(rest).reduce((acc, [key, value]) => {
      if (value === '1') {
        return [...acc, key]
      }

      return acc
    }, [])

    if (fileTypes) {
      activeFilters.push(...fileTypes.map(item => getFileTypeSlug(item, filtersOptions)))
    }

    if (licenses) {
      activeFilters.push(...licenses)
    }

    return activeFilters.join('+')
  }

  function handlePreviousSearch() {
    window.impressionsCounter = 0
    window.itemIdsBuffer = []
    window.trackableItems = []
    window.trackedItemIds = new Set()
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const keywords = urlParams.get('keywords') || ''
    const suggestedKeywords = urlParams.get('suggested_keywords') || ''
    const hasSetLastSelectedFilter = Object.keys(searchEnchantmentAction).length > 0
    const inheritedFilters = getSelectedFilters()

    if (!keywords && !suggestedKeywords && !hasSetLastSelectedFilter) {
      localStorage.removeItem('searchedKeywords')
      clearPreviousSearchUseStates()
      return
    }

    const fullKeywords = [keywords, suggestedKeywords.replace(/,/g, ' ')].join(' ').trim()
    const searchedKeywords = localStorage.getItem('searchedKeywords')
    if (!searchedKeywords) {
      clearPreviousSearchUseStates()
      if (hasSetLastSelectedFilter || suggestedKeywords) {
        setOriginalSearchQuery('search_')
        saveSearchedKeywords(fullKeywords, 'search_')
        if (hasSetLastSelectedFilter) {
          window.itemListEnrichmentType = searchEnchantmentAction
        } else {
          window.itemListEnrichmentType = {
            type: 'tag',
            value: fullKeywords.replace(/ /g, '+'),
          }
        }
        setSearchEnchantmentAction({})
        return
      }
      saveSearchedKeywords(fullKeywords)
      return
    }

    const parsedSearchedKeywords = JSON.parse(searchedKeywords)
    if (hasSetLastSelectedFilter) {
      setOriginalIndexes(parsedSearchedKeywords.items)
      window.itemListEnrichmentType = searchEnchantmentAction
      setSearchEnchantmentAction({})
      return
    }

    if (
      parsedSearchedKeywords.keywords === ''
      && parsedSearchedKeywords.searchEnchantmentAction
    ) {
      setOriginalIndexes(parsedSearchedKeywords.items)
      setOriginalSearchQuery(parsedSearchedKeywords.searchQuery)
      window.itemListEnrichmentType = {
        type: 'tag',
        value: fullKeywords.replace(/ /g, '+'),
      }

      return
    }

    if (fullKeywords.includes(parsedSearchedKeywords.keywords)) {
      setOriginalIndexes(parsedSearchedKeywords.items)
      setOriginalSearchQuery(parsedSearchedKeywords.searchQuery)
      window.itemListEnrichmentType = {
        type: 'tag',
        value: findStringDifference(parsedSearchedKeywords.keywords, fullKeywords),
      }
      return
    }

    saveSearchedKeywords(fullKeywords)
    if (inheritedFilters) {
      window.itemListEnrichmentType = {
        type: 'inherit',
        value: inheritedFilters,
      }
    }
  }

  useEffect(() => {
    if (shouldTrackSearch) {
      handlePreviousSearch()
      if (window && window.initItems && window.generateItemObserver) {
        window.initItems(window.generateItemObserver())
      }
      setShouldTrackSearch(false)
    }
  }, [shouldTrackSearch])

  return {
    originalIndexes,
    originalSearchQuery,
  }
}

export default useHandlePreviousSearch
